/* tslint:disable */
/* eslint-disable */
/**
 * PCO - Product & Services
 * API to test if access the application and get the current version
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface PreapprovalFormMetadata
 */
export interface PreapprovalFormMetadata {
    /**
     * 
     * @type {string}
     * @memberof PreapprovalFormMetadata
     */
    taskId?: string;
    /**
     * 
     * @type {boolean}
     * @memberof PreapprovalFormMetadata
     */
    workAccess?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof PreapprovalFormMetadata
     */
    isPmkTask?: boolean;
    /**
     * 
     * @type {string}
     * @memberof PreapprovalFormMetadata
     */
    taskName?: string;
    /**
     * 
     * @type {string}
     * @memberof PreapprovalFormMetadata
     */
    techId?: string;
    /**
     * 
     * @type {string}
     * @memberof PreapprovalFormMetadata
     */
    stepMetadataType: string;
    /**
     * 
     * @type {string}
     * @memberof PreapprovalFormMetadata
     */
    schema?: string;
}

/**
 * Check if a given object implements the PreapprovalFormMetadata interface.
 */
export function instanceOfPreapprovalFormMetadata(value: object): value is PreapprovalFormMetadata {
    if (!('stepMetadataType' in value) || value['stepMetadataType'] === undefined) return false;
    return true;
}

export function PreapprovalFormMetadataFromJSON(json: any): PreapprovalFormMetadata {
    return PreapprovalFormMetadataFromJSONTyped(json, false);
}

export function PreapprovalFormMetadataFromJSONTyped(json: any, ignoreDiscriminator: boolean): PreapprovalFormMetadata {
    if (json == null) {
        return json;
    }
    return {
        
        'taskId': json['taskId'] == null ? undefined : json['taskId'],
        'workAccess': json['workAccess'] == null ? undefined : json['workAccess'],
        'isPmkTask': json['isPmkTask'] == null ? undefined : json['isPmkTask'],
        'taskName': json['taskName'] == null ? undefined : json['taskName'],
        'techId': json['techId'] == null ? undefined : json['techId'],
        'stepMetadataType': json['stepMetadataType'],
        'schema': json['schema'] == null ? undefined : json['schema'],
    };
}

export function PreapprovalFormMetadataToJSON(json: any): PreapprovalFormMetadata {
    return PreapprovalFormMetadataToJSONTyped(json, false);
}

export function PreapprovalFormMetadataToJSONTyped(value?: PreapprovalFormMetadata | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'taskId': value['taskId'],
        'workAccess': value['workAccess'],
        'isPmkTask': value['isPmkTask'],
        'taskName': value['taskName'],
        'techId': value['techId'],
        'stepMetadataType': value['stepMetadataType'],
        'schema': value['schema'],
    };
}

